import { ANALYTICS_TYPES } from "../constants/AnalyticsTypeConstants";
import CleverTapAnalytics from "./type/CleverTapAnalytics";
import AdobeAnalytics from "./type/AdobeAnalytics";
import FacebookpixelAnalytics from "./type/FacebookpixelAnalytics";
import GoogleTagManager4Analytics from "./type/GoogleTagManager4Analytics";
import BranchIOAnalytics from "./type/BranchIOAnalytics";
import ClickStreamAnalytics from "./type/ClickstreamAnalytics";
import EvamAnalytics from "./type/EvamAnalytics";

class AnalyticsFactory {
  get() {
    const type = window.ANALYTICS_TYPE;
    if (!type) {
      //ByDefault initializing CleverTapAnalytics
      return CleverTapAnalytics;
    }
    const analyticsFile = ANALYTICS_TYPES[type];
    if (!analyticsFile) {
      throw new Error(
        "Invalid Analytics Type defined in environment config : " + type
      );
    }
    //Right now returning Adobe Analytics and we can change to return based on string later
    return AdobeAnalytics;
  }
  pushProfile(event, data, message, defaultAnalytics) {
    AdobeAnalytics.pushProfile(event, data, message);
    CleverTapAnalytics.pushProfile(event, data, message, defaultAnalytics);
  }
  pushEvent(event, data, message, reduxStore) {
    AdobeAnalytics.pushEvent(event, data, message);
    CleverTapAnalytics.pushEvent(event, data, message, reduxStore);
    FacebookpixelAnalytics.pushEvent(event, data, message);
    GoogleTagManager4Analytics.pushEvent(event, data, message, reduxStore);
    BranchIOAnalytics.pushEvent(event, data, message, reduxStore);
    ClickStreamAnalytics.pushEvent(event, data, message, reduxStore);
    EvamAnalytics.pushEvent(event, data, message, reduxStore);
  }
}

export default new AnalyticsFactory();
